import React, { useRef, useCallback } from 'react'
import { Overlay, Popover } from 'react-bootstrap'
import { useToggle } from 'react-use'
import styled from 'styled-components'
import SanitizedHtml from 'components/SanitizedHtml'

const StyledPopover = styled(Popover).withConfig({
  shouldForwardProp: (prop) => prop !== 'background',
})`
  .popover-body {
    border-bottom: 1px solid #ccc;
    margin: 0;
    padding: 0;
  }

  .popover-header {
    background-color: ${(props) => props.background};
    color: white;
  }

  &.bs-popover-auto[x-placement^='bottom'],
  &.bs-popover-bottom {
    .arrow::before,
    .arrow::after {
      border-bottom-color: ${(props) => props.background};
    }
  }

  &.bs-popover-auto[x-placement^='top'],
  &.bs-popover-top {
    .arrow::before,
    .arrow::after {
      border-top-color: ${(props) => props.background};
    }
  }

  &.bs-popover-auto[x-placement^='left'],
  &.bs-popover-left {
    .arrow::before,
    .arrow::after {
      border-left-color: ${(props) => props.background};
    }
  }

  &.bs-popover-auto[x-placement^='right'],
  &.bs-popover-right {
    .arrow::before,
    .arrow::after {
      border-right-color: ${(props) => props.background};
    }
  }
`

const Marker = ({ bg = null, x, y, scale = '', title, body, iconHref }) => {
  const target = useRef(null)
  const [on, toggle] = useToggle(false)

  const popover = useCallback(
    (props) => (
      <StyledPopover className="border-0" background={bg} {...props}>
        <Popover.Title className="px-3" id={title}>
          {title}
        </Popover.Title>
        {body ? (
          <Popover.Content className="px-3">
            <SanitizedHtml html={body} />
          </Popover.Content>
        ) : null}
      </StyledPopover>
    ),
    []
  )

  return (
    <g
      ref={target}
      onMouseEnter={toggle}
      onMouseLeave={toggle}
      transform={`translate(${x}, ${y}) ${scale ? `scale(${scale})` : ''}`}
    >
      <use href={iconHref} />
      <Overlay
        target={target.current}
        show={on}
        flip
        placement="right-start"
        children={popover}
        popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-10, 8],
              },
            },
          ],
        }}
      />
    </g>
  )
}

export default React.memo(Marker)
